import { Translate } from '@chipinside/translate'
import { Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { CSSProperties } from 'react'

import { Icon as AppIcon } from '#/components/Icon'
import Colors from '#/styles/Colors'

const Label = styled('p')({
  color: '#666',
  fontWeight: 500,
  lineHeight: '16px',
  margin: 0,
})

const Content = styled('div')(({ orientation }: { orientation: TypePPIProps['orientation'] }) => ({
  alignItems: 'center',
  columnGap: 8,
  display: 'flex',
  flexDirection: orientation,
}))

const Icon = styled(AppIcon)(({ status }: { status: PPI['status'] }) => ({
  color: Colors.ppi[status],
  fontSize: 25,
  height: '30px',
}))

export type PPI = {
  status: 'challenge' | 'normal'
  text: string
}

export type TypePPIProps = {
  value: PPI
  orientation: CSSProperties['flexDirection']
  textStyle: CSSProperties
}

const TypePPI = ({ orientation = 'column', textStyle, value }: TypePPIProps) => {
  const { status, text } = value ?? {}

  if (!status) {
    return <span>-</span>
  }

  return (
    <Tooltip title={`${Translate({ messageKey: 'ppi' })} - ${text}`}>
      <Content orientation={orientation}>
        <Icon size="large" name="ppi" status={status} />
        <Label style={textStyle}>{text}</Label>
      </Content>
    </Tooltip>
  )
}

export { TypePPI }
